import cx from "classnames";
import Link from "next/link";
import type React from "react";
import styles from "./styles.module.css";

type BaseLinkProps = {
	text: string;
	href: string;
	color?: "white" | "black";
	type?: "default" | "header" | "button";
	className?: string;
};
/// title={text}
const BaseLink: React.FC<BaseLinkProps> = ({
	text,
	href,
	color = "black",
	type = "default",
	className = "",
}) => {
	return (
		<Link
			href={href}
			className={cx(styles.link, styles[color], styles[type], className)}
		>
			{text}
		</Link>
	);
};

export default BaseLink;
